import ActionNames from '../../actions/names';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: false,
  data: {},
  classicData: {},
  saasData: {},
  athData: {},
  libertyData: {},
  templatedData: {},
  liteData: {},
  competitorData: {},
  error: null
});

function summaryDataReducer(state = initialState, action) {
  switch (action.type) {
    case ActionNames.REQUEST_LIGHTHOUSE_SUMMARY_FOR_PLATFORM:
      return state.merge({ data: {}, loading: true });
    case ActionNames.RECEIVE_LIGHTHOUSE_SUMMARY_FOR_PLATFORM:
      return state.merge({ [`${action.platform}SummaryData`]: action.data });
    case ActionNames.FAILURE_LIGHTHOUSE_SUMMARY_FOR_PLATFORM:
      return state.merge({ error: action.error, loading: false });
    default:
      return state;
  }
}

export default summaryDataReducer;
